<template>
  <div>処理の完了を待っています。しばらくおまちください......</div>
</template>

<script setup lang="ts">
window.opener.postMessage("success");
window.close();
</script>
